let HotelPriceSortType = {
  CUSTOM: '--Selecione--',
  LOWEST_PRICE: 'Menor preço',
  HIGHEST_PRICE: 'Maior preço',
  STAR_RATING: 'Categoria do Hotel',
  HOTEL_NAME: 'Ordem Alfabética',
  EVENT_DISTANCE: 'Distância do evento'
};

export default HotelPriceSortType;
export const hotelPriceSortTypes = Object.keys(HotelPriceSortType).map(key => HotelPriceSortType[key]);



// WEBPACK FOOTER //
// ./src/enums/HotelPriceSortType.js